import React from 'react';

import { ElementCategoryID } from '@shared/models/element-categories.model';

import { ICategoryGroup } from '../../hooks/use-grouped-element-categories.hook';
import { CategoryType } from '@shared/helpers/element-category.helpers';
import { Menu } from '@ui/menus/Menu';
import { Icon } from '@ui/Icon';
import { getElementIconCategoryName } from '@features/elements/helpers/get-element-category-icon-name.helper';

type ElementCategoryMenuContentProps = {
  categoryGroups: ICategoryGroup<{
    disabled: false | string;
    type: CategoryType;
  }>[];
  selectedCategoryId?: ElementCategoryID;
  onSelect: (categoryId: ElementCategoryID) => void;
};

export const ElementCategoryMenuContent: React.FC<
  ElementCategoryMenuContentProps
> = ({ categoryGroups, selectedCategoryId, onSelect }) => {
  if (!categoryGroups.length) return null;

  return (
    <>
      {categoryGroups.map((group, index) => (
        <React.Fragment key={group.id}>
          {index > 0 && <Menu.Divider />}
          <Menu.Group label={group.name}>
            {group.categories.map((category) => (
              <Menu.Item
                key={category.id}
                icon={
                  <Icon
                    category="elementCategory"
                    icon={getElementIconCategoryName(category.id)}
                  />
                }
                disabled={category.meta.disabled !== false}
                selected={category.id === selectedCategoryId}
                searchText={`${group.name} ${category.name}`.trim()}
                onClick={() => onSelect(category.id)}
              >
                {category.name}
              </Menu.Item>
            ))}
          </Menu.Group>
        </React.Fragment>
      ))}
    </>
  );
};
